import React, { useEffect, useCallback, useState, useRef } from "react";
import {
  Layout,
  Menu,
  Input,
  Badge,
  Dropdown,
  Breadcrumb,
  theme,
  Modal,
  Typography,
  Button,
  notification,
  Alert,
} from "antd";
import axios from "axios";
import { Popover, List } from "antd";

import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  SettingOutlined,
  BellOutlined,
  IdcardTwoTone,
  LeftOutlined,
  CameraOutlined,
  DeleteOutlined,
  CloseOutlined,
  InboxOutlined,
  FundViewOutlined,
  ClearOutlined,
  RadarChartOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  AlertOutlined,
  CheckCircleOutlined,
  ScanOutlined,
  PrinterOutlined,
  FolderOutlined,
  DashboardOutlined
} from "@ant-design/icons";
import { Row, Col, Card } from "antd";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { useForm, Controller } from "react-hook-form";
import {
  RightOutlined,
  FolderOpenOutlined,
  DashboardTwoTone,
  UserOutlined,
  BankTwoTone,
  SettingTwoTone,
  DatabaseTwoTone,
} from "@ant-design/icons";
import DepartmentSelect from "../Models/DepartmentSelect.js/DepartmentSelect.js";
import UserApi from "../Apis/UserApi.js";
import Contact from "../Models/Contact/Contact.js";
import StockApi from "../Apis/StockApi.js";
import RuntimeConfigsApi from "../Apis/RuntimeConfigsApi.js";
import Notifications from "./Notifications.js";
import pako from "pako";
import jwt_decode from "jwt-decode";

const TopHeader = ({ onPrintResponse, onPrintResponse2 }) => {
  const { Title } = Typography;
  let navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [firstName, setfirstName] = useState("");
  const UserDetail = JSON.parse(localStorage.getItem("UserDetails"));
  const urlParams = new URLSearchParams(window.location.search);
  const invoice = urlParams.get("invoice_id");
  const batch = urlParams.get("batch");
  const [quickCode, setQuickCode] = useState("");



  const hadletcost = () => {
    if (batch === null) {
      return true;
    } else {
      return false;
    }
  }

  const handleQuickLogin = async (data) => {
    if (!quickCode) {
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Please enter the quick login code.</span>,
        closeIcon: false,
        duration: 3,
        style: {
          backgroundColor: "#ffb3b3",
          color: "red",
        },
      });
      return;
    }

    try {
      // 1. Get public IP
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const publicIp = ipData.ip;

      // 2. Prepare form data
      const formData = new FormData();
      formData.append("userId", quickCode);
      formData.append("ipAddress", publicIp); // <-- use dynamic IP here
      formData.append("laptopMac", "12345"); // (replace with real MAC if you capture it)

      // 3. Call API
      const response = await UserApi.loginWithCode(formData);

      // setLoadings(false);

      // 4. Save JWT + decode
      localStorage.setItem("UserjwtToken", response?.payload?.jwtToken);

      const compressedData = Uint8Array.from(
        atob(response?.payload?.jwtToken),
        (c) => c.charCodeAt(0)
      );
      const decompressedData = pako.inflate(compressedData, { to: "string" });
      const decodedToken = jwt_decode(decompressedData);
      localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
      localStorage.setItem("loginCodeUsed", true);

      // 5. Notification + redirect
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>,
        description: "Welcome " + decodedToken.name,
        closeIcon: false,
        duration: 3,
        style: { backgroundColor: "#b3ffb3", color: "green" },
      });

      // setTimeout(() => navigate("/dashboard"), 3000);
      setTimeout(() => {
        window.location.reload();
      }, 3000);

    } catch (err) {
      // setLoadings(false);
      console.error(err);
      notification.open({
        message: <span style={{ fontWeight: "bold" }}>Error</span>,
        description: err?.apiError?.message || "Something went wrong",
        closeIcon: false,
        duration: 3,
        style: { backgroundColor: "#ffb3b3", color: "red" },
      });
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm();
  const location = useLocation();

  const { useToken } = theme;
  const { token } = useToken();
  const breadcrumbUrls = location.pathname.split("/").filter(Boolean);
  const lastBreadcrumbUrl = breadcrumbUrls[breadcrumbUrls.length - 1];
  const lastBreadcrumb2 = breadcrumbUrls[breadcrumbUrls?.length - 2];
  const modifiedBreadcrumbUrls = breadcrumbUrls.map((url) => {
  const modifiedUrl = url.replace(/-/g, " ");

  return modifiedUrl.toLowerCase() === "complaint reply"
    ? "Corrective Action Issues and Replies"
    : modifiedUrl;
});

  const handleClickPrint = () => {
    onPrintResponse("asd");
  };
  const handleClickPrint2 = () => {
    onPrintResponse2();
  };
  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const isSubtenantADMIN = decodedToken?.roles.includes("SUB_TENANT_ADMIN");
  const isSubtenantUser = decodedToken?.roles.includes("SUB_TENANT_USER");

  const [UserDetails, setUserDetails] = useState();
  const [SelectedProfile, setSelectedProfile] = useState();
  const splitName = decodedToken?.name.split(" ");
  const ProfileImage = useCallback(() => {
    UserApi.UserDetails()
      .then((response) => {
        const SelectedProfile =
          response?.payload?.userProfileFileResourceList.filter(
            (item) => item?.selected === true
          );
        localStorage.setItem(
          `SelectedProfile`,
          JSON.stringify(SelectedProfile)
        );
        setSelectedProfile(SelectedProfile);
        setUserDetails(response?.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const [TotalCost, setTotalCost] = useState(null);
  const [TotalData, setTotalData] = useState([]);
  const getCostTotal = useCallback(() => {
   StockApi.ListStockInvoiceCost(invoice,0,100)
  .then((response) => {
    let totalCost = 0;
    response?.payloadDto?.forEach((item) => {
      const quantity = parseFloat(item?.initQuantity);
      const costPrice = item?.productDTOs[0]?.costPriceUoM2;
      
      // Check if both values are valid numbers
      if (!isNaN(quantity) && !isNaN(costPrice) && quantity > 0 && costPrice > 0) {
        totalCost += quantity * costPrice;
      }
    });
    setTotalCost(totalCost);
    setTotalData(response?.payloadDto);
  })
  .catch((err) => {
    // Handle error
    console.error("Error fetching stock invoice cost:", err);
  });
  }, [invoice]);



  useEffect(() => {
    if (decodedToken) {
      setfirstName(splitName[0]?.charAt(0));
      ProfileImage();
    } else {
      return navigate("/");
    }
    if (lastBreadcrumbUrl === "stock-list" || lastBreadcrumbUrl === "stock") {
      getCostTotal();
    }
  }, [ProfileImage]);

  const [modalContactVisible, setModalContactVisible] = useState(false);

  const handleOpenContactModal = () => {
    setModalContactVisible(true);
    setDropdownVisible(false);
  };
  const handlContactCloseModal = () => {
    setModalContactVisible(false);
  };

  useEffect(() => {
    if (lastBreadcrumbUrl === "reheat") {
      if (
        !decodedToken?.permissions?.some(
          (permission) => permission?.authority === "DELETE_ALLERGENS"
        )
      ) {
        return navigate("/dashboard");
      }
    }
    if (lastBreadcrumbUrl === "reheat") {
      if (
        !decodedToken?.permissions?.some(
          (permission) => permission?.authority === "DELETE_ALLERGENS"
        )
      ) {
        return navigate("/dashboard");
      }
    }

    if (decodedToken?.roles.includes("SUPER_ADMIN")) {
      getRuntimeConfigs();
    }
  }, [navigate, decodedToken]);

  const [modalcurrencyVisible, setModalCurrency] = useState(false);
  const [modalTimeVisible, setmodalTimeVisible] = useState(false);
  const [ADMIN_PERMISSION, setmodalTADMIN_PERMISSION] = useState(false);

  const getRuntimeConfigs = useCallback(() => {
    RuntimeConfigsApi.ListRuntimeConfigs()
      .then((response) => {
        if (
          response.payloadDto.filter(
            (item) => item?.tag === "CURRENCY_TYPE_CONFIG"
          ).length === 0
        ) {
          // setModalCurrency(true);
          // setEnableTenacy(true);
          if (lastBreadcrumbUrl === "currency-configurations") {
            setEnableTenacy(false);

          } else {
            setEnableTenacy(true);
            setModalCurrency(true);

          }
        }
        if (
          response?.payloadDto.filter(
            (item) =>
              item?.configKey === "TRIGGER_TIME1" &&
              item?.environment === token?.environment
          ).length === 0
        ) {

          if (lastBreadcrumbUrl === "time-configurations") {
            setEnableTenacy(false);
          } else {
            setEnableTenacy(true);
            setmodalTimeVisible(true);

          }


        }
        if (
          response?.payloadDto.filter(
            (item) =>
              item?.configKey === "TENANT_ADMIN_PERMISSION_SETTING" &&
              item?.configValue === "false" &&
              item?.environment === token?.environment
          ).length !== 0
        ) {
          if (lastBreadcrumbUrl === "set-permissions") {
            setEnableTenacy(false);
            // setModalCurrency(true);
          } else {
            setEnableTenacy(true);
            setmodalTADMIN_PERMISSION(true);
            setModalCurrency(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const { Header } = Layout;
  const { Search } = Input;
  const handleClearSession = () => {
    localStorage.clear();
    sessionStorage.clear();
    return navigate("/");
  };
  const handleChangePassword = () => {
    return navigate("/change-newpassword");
  };
  const handleOpenAccountModal = () => {
    return navigate("/manage-account");
  };

  const handleOpenCompanyProfile = () => {
    return navigate("/company/profile");
  };

  const [isModalProfile, setIsModalProfile] = useState(false);

  const showProfile = () => {
    setIsModalProfile(true);
    setDropdownVisible(false);
  };
  const handleOk = () => {
    setIsModalProfile(false);
  };
  const handleCancelProfile = () => {
    setIsModalProfile(false);
  };

  const [EnableTenacy, setEnableTenacy] = useState(false);
  const handleCancelProduct = () => {
    setEnableTenacy(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const RemoveImage = () => {
    UserApi.UserProfileDelete(SelectedProfile[0]?.id)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Removed</span>,
          description: "Removed Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: err?.response?.data?.apiError?.message,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      });
  };
  const renderIcons = () => {
    if (lastBreadcrumbUrl === "dashboard") {
      return <DashboardTwoTone className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "settings" ||
      lastBreadcrumbUrl === "currency-configurations" ||
      lastBreadcrumbUrl === "time-configurations" ||
      lastBreadcrumbUrl === "video-configurations" ||
      lastBreadcrumbUrl === "sensor-configurations" ||
      lastBreadcrumbUrl === "twilio-configurations" ||
      lastBreadcrumbUrl === "add-twilio-configurations" ||
      lastBreadcrumbUrl === "edit-configurations" ||
      lastBreadcrumbUrl === "set-permissions"
    ) {
      return <SettingTwoTone className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "product-master-sheet" ||
      lastBreadcrumb2 === "product"
    ) {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.1673 8.16665L14.5007 2.33331L2.83398 8.16665V19.8333L14.5007 25.6666L26.1673 19.8333V8.16665Z"
            stroke="#3E55A4"
            strokeWidth="2.33333"
            strokeLinejoin="round"
          />
          <path
            d="M2.83398 8.16667L14.5007 14M14.5007 14V25.6667M14.5007 14L26.1673 8.16667M20.334 5.25L8.66732 11.0833"
            stroke="#3E55A4"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "hot-hold") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.125 5.625L7.25 11.875L11.125 18.375L7 25.625L4.75 24.5L8.125 18.375L4.25 11.875L8.875 4.5L11.125 5.625ZM18.875 5.5L15 11.875L18.875 18.125L14.75 25.375L12.5 24.25L15.875 18.125L12 11.875L16.625 4.375L18.875 5.5ZM26.75 5.5L22.875 11.875L26.75 18.125L22.625 25.375L20.375 24.25L23.75 18.125L19.875 11.875L24.5 4.375L26.75 5.5Z"
            fill="#3E55A4"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "reheat") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 25 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 15.0163C3.5 16.1813 3.7625 17.2849 4.2875 18.3272C4.8125 19.3694 5.5625 20.2821 6.5375 21.0654C6.5125 20.9534 6.5 20.8525 6.5 20.7629V20.4605C6.5 19.7435 6.65 19.0714 6.95 18.4441C7.25 17.8168 7.6875 17.2455 8.2625 16.7302L12.5 13L16.7375 16.7302C17.3125 17.2455 17.75 17.8168 18.05 18.4441C18.35 19.0714 18.5 19.7435 18.5 20.4605V20.7629C18.5 20.8525 18.4875 20.9534 18.4625 21.0654C19.4375 20.2812 20.1875 19.3681 20.7125 18.3258C21.2375 17.2836 21.5 16.1804 21.5 15.0163C21.5 13.8961 21.2685 12.8373 20.8055 11.8399C20.3425 10.8425 19.674 9.95217 18.8 9.16893C18.3 9.46018 17.775 9.67884 17.225 9.82492C16.675 9.97099 16.1125 10.0436 15.5375 10.0427C13.9875 10.0427 12.6435 9.5834 11.5055 8.66484C10.3675 7.74629 9.7115 6.61489 9.5375 5.27066C8.5625 6.00999 7.7 6.77755 6.95 7.57333C6.2 8.36911 5.5685 9.17565 5.0555 9.99294C4.5435 10.8102 4.1565 11.6446 3.8945 12.4959C3.6325 13.3472 3.501 14.1874 3.5 15.0163ZM12.5 16.7638L10.3625 18.6458C10.0875 18.8922 9.875 19.1723 9.725 19.4859C9.575 19.7996 9.5 20.1244 9.5 20.4605C9.5 21.1774 9.7935 21.7935 10.3805 22.3088C10.9675 22.8241 11.674 23.0817 12.5 23.0817C13.325 23.0817 14.031 22.8241 14.618 22.3088C15.205 21.7935 15.499 21.1774 15.5 20.4605C15.5 20.102 15.425 19.7713 15.275 19.4684C15.125 19.1655 14.9125 18.8913 14.6375 18.6458L12.5 16.7638ZM12.5 0.229797V4.66576C12.5 5.42749 12.794 6.066 13.382 6.58129C13.97 7.09658 14.6885 7.35422 15.5375 7.35422C15.9875 7.35422 16.4065 7.26998 16.7945 7.10151C17.1825 6.93303 17.526 6.68121 17.825 6.34605L18.5 5.60672C20.35 6.54768 21.8125 7.85831 22.8875 9.5386C23.9625 11.2189 24.5 13.0448 24.5 15.0163C24.5 18.0185 23.3375 20.5613 21.0125 22.6448C18.6875 24.7284 15.85 25.7702 12.5 25.7702C9.15 25.7702 6.3125 24.7284 3.9875 22.6448C1.6625 20.5613 0.5 18.0185 0.5 15.0163C0.5 12.1262 1.581 9.38177 3.743 6.78292C5.905 4.18408 8.824 1.9997 12.5 0.229797Z"
            fill="#3E55A4"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "cooling-process") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.44479 22.2969C7.95938 21.7372 6.74306 20.8059 5.79583 19.503C4.84861 18.2001 4.375 16.7096 4.375 15.0312C4.375 13.3306 4.77886 11.818 5.58658 10.4936C6.39431 9.16924 7.28211 8.05539 8.25 7.15208C9.21875 6.24792 10.107 5.55903 10.9147 5.08542L12.125 4.375V7.57187C12.125 8.11007 12.3187 8.56775 12.7062 8.94492C13.0937 9.32208 13.5566 9.51024 14.0948 9.50937C14.3962 9.50937 14.676 9.44479 14.9344 9.31562C15.1927 9.18646 15.408 9.00347 15.5802 8.76667L16 8.25C16.8181 8.72361 17.5177 9.30486 18.099 9.99375C18.6802 10.6826 19.1215 11.4576 19.4229 12.3187L17.2594 14.4823C17.2163 13.9656 17.0923 13.4597 16.8874 12.9646C16.6824 12.4694 16.4082 12.0174 16.0646 11.6083C15.7632 11.7806 15.4454 11.9046 15.1113 11.9803C14.7772 12.0561 14.4384 12.0936 14.0948 12.0927C13.1476 12.0927 12.2916 11.8288 11.527 11.3009C10.7623 10.7731 10.2082 10.0682 9.86458 9.18646C9.04653 9.98299 8.35764 10.8712 7.79792 11.8512C7.23819 12.8311 6.95833 13.8911 6.95833 15.0312C6.95833 15.6986 7.07674 16.3285 7.31354 16.921C7.55035 17.5134 7.87326 18.0352 8.28229 18.4865C8.32535 18.0559 8.44935 17.652 8.65429 17.2749C8.85924 16.8977 9.11197 16.5589 9.4125 16.2583L12.125 13.5458L14.9021 16.2583C14.9451 16.3014 14.9882 16.3552 15.0312 16.4198C15.0743 16.4844 15.1174 16.5382 15.1604 16.5812L13.3198 18.4219C13.2767 18.3573 13.2388 18.3035 13.2061 18.2604C13.1734 18.2174 13.1359 18.1743 13.0938 18.1312L12.125 17.1948L11.2208 18.099C11.1132 18.2066 11.0215 18.3306 10.9457 18.471C10.8699 18.6113 10.8325 18.7672 10.8333 18.9385C10.8333 19.1969 10.9087 19.4281 11.0594 19.6322C11.2101 19.8363 11.4038 19.9925 11.6406 20.101L9.44479 22.2969ZM10.0583 28.9167L8.25 27.1083L25.8167 9.54167L27.625 11.35L22.975 16H27.625V18.5833H20.3917L19.7458 19.2292L21.6833 21.1667H27.625V23.75H24.2667L26.9792 26.4625L25.1708 28.2708L22.4583 25.5583V28.9167H19.875V22.975L17.9375 21.0375L17.2917 21.6833V28.9167H14.7083V24.2667L10.0583 28.9167Z"
            fill="#3E55A4"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "after-cook") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 10.5H27M10.75 3V5.5M17 1.75V5.5M23.25 3V5.5M25.75 20.5V10.5H8.25V20.5C8.25 21.4946 8.64509 22.4484 9.34835 23.1517C10.0516 23.8549 11.0054 24.25 12 24.25H22C22.9946 24.25 23.9484 23.8549 24.6517 23.1517C25.3549 22.4484 25.75 21.4946 25.75 20.5Z"
            stroke="#3E55A4"
            strokeWidth="2.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "good-inward-process") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.045 5.58C20.2557 5.79094 20.374 6.07687 20.374 6.375C20.374 6.67313 20.2557 6.95906 20.045 7.17L16.295 10.92C16.0841 11.1307 15.7981 11.249 15.5 11.249C15.2019 11.249 14.9159 11.1307 14.705 10.92L10.955 7.17C10.7563 6.95674 10.6481 6.67467 10.6532 6.38322C10.6584 6.09176 10.7764 5.81369 10.9826 5.60757C11.1887 5.40145 11.4668 5.28338 11.7582 5.27824C12.0497 5.2731 12.3317 5.38128 12.545 5.58L14.375 7.41V2.625C14.375 2.32663 14.4935 2.04048 14.7045 1.8295C14.9155 1.61853 15.2016 1.5 15.5 1.5C15.7984 1.5 16.0845 1.61853 16.2955 1.8295C16.5065 2.04048 16.625 2.32663 16.625 2.625V7.41L18.455 5.58C18.6659 5.36932 18.9519 5.25099 19.25 5.25099C19.5481 5.25099 19.8341 5.36932 20.045 5.58ZM6.08 10.455C6.29094 10.2443 6.57687 10.126 6.875 10.126C7.17313 10.126 7.45906 10.2443 7.67 10.455L11.42 14.205C11.6307 14.4159 11.749 14.7019 11.749 15C11.749 15.2981 11.6307 15.5841 11.42 15.795L7.67 19.545C7.45674 19.7437 7.17467 19.8519 6.88322 19.8468C6.59176 19.8416 6.31369 19.7236 6.10757 19.5174C5.90145 19.3113 5.78338 19.0332 5.77824 18.7418C5.7731 18.4503 5.88128 18.1683 6.08 17.955L7.91 16.125H3.125C2.82663 16.125 2.54048 16.0065 2.3295 15.7955C2.11853 15.5845 2 15.2984 2 15C2 14.7016 2.11853 14.4155 2.3295 14.2045C2.54048 13.9935 2.82663 13.875 3.125 13.875H7.91L6.08 12.045C5.86932 11.8341 5.75099 11.5481 5.75099 11.25C5.75099 10.9519 5.86932 10.6659 6.08 10.455ZM23.33 10.455C23.433 10.3445 23.5572 10.2558 23.6952 10.1943C23.8332 10.1328 23.9822 10.0998 24.1332 10.0971C24.2843 10.0944 24.4343 10.1222 24.5744 10.1788C24.7145 10.2354 24.8417 10.3196 24.9486 10.4264C25.0554 10.5333 25.1396 10.6605 25.1962 10.8006C25.2528 10.9407 25.2806 11.0907 25.2779 11.2418C25.2752 11.3928 25.2422 11.5418 25.1807 11.6798C25.1192 11.8178 25.0305 11.942 24.92 12.045L23.09 13.875H27.875C28.1734 13.875 28.4595 13.9935 28.6705 14.2045C28.8815 14.4155 29 14.7016 29 15C29 15.2984 28.8815 15.5845 28.6705 15.7955C28.4595 16.0065 28.1734 16.125 27.875 16.125H23.09L24.92 17.955C25.0305 18.058 25.1192 18.1822 25.1807 18.3202C25.2422 18.4582 25.2752 18.6072 25.2779 18.7582C25.2806 18.9093 25.2528 19.0593 25.1962 19.1994C25.1396 19.3395 25.0554 19.4667 24.9486 19.5736C24.8417 19.6804 24.7145 19.7646 24.5744 19.8212C24.4343 19.8778 24.2843 19.9056 24.1332 19.9029C23.9822 19.9002 23.8332 19.8672 23.6952 19.8057C23.5572 19.7442 23.433 19.6555 23.33 19.545L19.58 15.795C19.3693 15.5841 19.251 15.2981 19.251 15C19.251 14.7019 19.3693 14.4159 19.58 14.205L23.33 10.455ZM20.045 24.42C20.2557 24.2091 20.374 23.9231 20.374 23.625C20.374 23.3269 20.2557 23.0409 20.045 22.83L16.295 19.08C16.0841 18.8693 15.7981 18.751 15.5 18.751C15.2019 18.751 14.9159 18.8693 14.705 19.08L10.955 22.83C10.8445 22.933 10.7558 23.0572 10.6943 23.1952C10.6328 23.3332 10.5998 23.4822 10.5971 23.6332C10.5944 23.7843 10.6222 23.9343 10.6788 24.0744C10.7354 24.2145 10.8196 24.3417 10.9264 24.4486C11.0333 24.5554 11.1605 24.6396 11.3006 24.6962C11.4407 24.7528 11.5907 24.7806 11.7418 24.7779C11.8928 24.7752 12.0418 24.7422 12.1798 24.6807C12.3178 24.6192 12.442 24.5305 12.545 24.42L14.375 22.59V27.375C14.375 27.6734 14.4935 27.9595 14.7045 28.1705C14.9155 28.3815 15.2016 28.5 15.5 28.5C15.7984 28.5 16.0845 28.3815 16.2955 28.1705C16.5065 27.9595 16.625 27.6734 16.625 27.375V22.59L18.455 24.42C18.6659 24.6307 18.9519 24.749 19.25 24.749C19.5481 24.749 19.8341 24.6307 20.045 24.42Z"
            fill="#3E55A4"
          />
        </svg>
      );
    } else if (lastBreadcrumbUrl === "cold-traceability") {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 31 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1099_1405)">
            <path
              d="M27.166 11.0167V24.1667H3.83268V5.83335H19.3077C19.2695 5.5572 19.2501 5.27879 19.2493 5.00002C19.2502 4.72085 19.2693 4.44252 19.3077 4.16669H3.83268C3.39065 4.16669 2.96673 4.34228 2.65417 4.65484C2.34161 4.9674 2.16602 5.39133 2.16602 5.83335V24.1667C2.16602 24.6087 2.34161 25.0326 2.65417 25.3452C2.96673 25.6578 3.39065 25.8334 3.83268 25.8334H27.166C27.608 25.8334 28.032 25.6578 28.3445 25.3452C28.6571 25.0326 28.8327 24.6087 28.8327 24.1667V10.2834C28.316 10.6084 27.7543 10.855 27.166 11.0167Z"
              fill="#3E55A4"
            />
            <path
              d="M7.16602 8.33331H20.2727C20.5862 8.82911 20.9683 9.27801 21.4077 9.66665H18.7493V14.3333H22.166V10.2391C22.6812 10.5697 23.243 10.8211 23.8327 10.985V21.6666H7.16602V8.33331ZM8.49935 20H12.2493V15.6666H8.49935V20ZM12.2493 9.66665H8.49935V14.3333H12.2493V9.66665ZM22.166 20V15.6666H18.7493V20H22.166ZM13.5827 9.66665V14.3333H17.416V9.66665H13.5827ZM13.5827 20H17.416V15.6666H13.5827V20Z"
              fill="#3E55A4"
            />
            <path
              d="M25.5007 9.16665C27.8018 9.16665 29.6673 7.30117 29.6673 4.99998C29.6673 2.69879 27.8018 0.833313 25.5007 0.833313C23.1995 0.833313 21.334 2.69879 21.334 4.99998C21.334 7.30117 23.1995 9.16665 25.5007 9.16665Z"
              fill="#3E55A4"
            />
          </g>
          <defs>
            <clipPath id="clip0_1099_1405">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    } else if (
      lastBreadcrumbUrl === "production" ||
      lastBreadcrumbUrl === "live-stock"
    ) {
      return (
        <svg
          width="50"
          height="50"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.64648 4.08301C7.06632 4.08301 6.50992 4.31348 6.09969 4.72371C5.68945 5.13395 5.45898 5.69035 5.45898 6.27051V9.39551C5.45898 10.603 6.43898 11.583 7.64648 11.583H10.7715C11.3516 11.583 11.908 11.3525 12.3183 10.9423C12.7285 10.5321 12.959 9.97567 12.959 9.39551V6.27051C12.959 5.69035 12.7285 5.13395 12.3183 4.72371C11.908 4.31348 11.3516 4.08301 10.7715 4.08301H7.64648ZM16.709 6.27051C16.709 5.06301 17.689 4.08301 18.8965 4.08301H22.0215C23.229 4.08301 24.209 5.06301 24.209 6.27051V9.39551C24.209 9.97567 23.9785 10.5321 23.5683 10.9423C23.158 11.3525 22.6016 11.583 22.0215 11.583H18.8965C18.3163 11.583 17.7599 11.3525 17.3497 10.9423C16.9395 10.5321 16.709 9.97567 16.709 9.39551V6.27051ZM18.8965 5.95801C18.8136 5.95801 18.7341 5.99093 18.6755 6.04954C18.6169 6.10814 18.584 6.18763 18.584 6.27051V9.39551C18.584 9.56801 18.724 9.70801 18.8965 9.70801H22.0215C22.1044 9.70801 22.1839 9.67508 22.2425 9.61648C22.3011 9.55787 22.334 9.47839 22.334 9.39551V6.27051C22.334 6.18763 22.3011 6.10814 22.2425 6.04954C22.1839 5.99093 22.1044 5.95801 22.0215 5.95801H18.8965ZM8.58398 21.583C9.08127 21.583 9.55818 21.3855 9.90981 21.0338C10.2614 20.6822 10.459 20.2053 10.459 19.708C10.459 19.2107 10.2614 18.7338 9.90981 18.3822C9.55818 18.0306 9.08127 17.833 8.58398 17.833C8.0867 17.833 7.60979 18.0306 7.25816 18.3822C6.90653 18.7338 6.70898 19.2107 6.70898 19.708C6.70898 20.2053 6.90653 20.6822 7.25816 21.0338C7.60979 21.3855 8.0867 21.583 8.58398 21.583ZM16.709 19.708C16.709 20.2053 16.5114 20.6822 16.1598 21.0338C15.8082 21.3855 15.3313 21.583 14.834 21.583C14.3367 21.583 13.8598 21.3855 13.5082 21.0338C13.1565 20.6822 12.959 20.2053 12.959 19.708C12.959 19.2107 13.1565 18.7338 13.5082 18.3822C13.8598 18.0306 14.3367 17.833 14.834 17.833C15.3313 17.833 15.8082 18.0306 16.1598 18.3822C16.5114 18.7338 16.709 19.2107 16.709 19.708ZM21.084 21.583C21.5813 21.583 22.0582 21.3855 22.4098 21.0338C22.7614 20.6822 22.959 20.2053 22.959 19.708C22.959 19.2107 22.7614 18.7338 22.4098 18.3822C22.0582 18.0306 21.5813 17.833 21.084 17.833C20.5867 17.833 20.1098 18.0306 19.7582 18.3822C19.4065 18.7338 19.209 19.2107 19.209 19.708C19.209 20.2053 19.4065 20.6822 19.7582 21.0338C20.1098 21.3855 20.5867 21.583 21.084 21.583ZM2.33398 19.708C2.33398 18.2162 2.92662 16.7854 3.98151 15.7305C5.0364 14.6756 6.46714 14.083 7.95898 14.083H21.709C23.2008 14.083 24.6316 14.6756 25.6865 15.7305C26.7414 16.7854 27.334 18.2162 27.334 19.708C27.334 21.1999 26.7414 22.6306 25.6865 23.6855C24.6316 24.7404 23.2008 25.333 21.709 25.333H7.95898C6.46714 25.333 5.0364 24.7404 3.98151 23.6855C2.92662 22.6306 2.33398 21.1999 2.33398 19.708ZM7.95898 15.958C6.96442 15.958 6.0106 16.3531 5.30733 17.0564C4.60407 17.7596 4.20898 18.7134 4.20898 19.708C4.20898 20.7026 4.60407 21.6564 5.30733 22.3597C6.0106 23.0629 6.96442 23.458 7.95898 23.458H21.709C22.7035 23.458 23.6574 23.0629 24.3606 22.3597C25.0639 21.6564 25.459 20.7026 25.459 19.708C25.459 18.7134 25.0639 17.7596 24.3606 17.0564C23.6574 16.3531 22.7035 15.958 21.709 15.958H7.95898Z"
            fill="#3E55A4"
          />
        </svg>
      );
    } else if (
      lastBreadcrumbUrl === "stock-list" ||
      lastBreadcrumbUrl === "stock"
    ) {
      return <FundViewOutlined className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "complaints" ||
      lastBreadcrumbUrl === "create-complaint" ||
      lastBreadcrumbUrl === "complaint-reply"
    ) {
      return <IdcardTwoTone className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "fridge-temperature-report" ||
      lastBreadcrumbUrl === "inventory-reports" ||
      lastBreadcrumbUrl === "waste-reports" ||
      lastBreadcrumbUrl === "raw-waste-reports"
    ) {
      return <FolderOutlined className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "daily-cleaning-traceability" ||
      lastBreadcrumbUrl === "cleaning-traceability" ||
      lastBreadcrumb2 === "cleaning-traceability" ||
      lastBreadcrumbUrl === "cleaning-list" ||
      lastBreadcrumbUrl === "add-cleaning-traceability-item" ||
      lastBreadcrumbUrl === "edit-cleaning-traceability-item" ||
      lastBreadcrumbUrl === "weekly-cleaning-traceability" ||
      lastBreadcrumbUrl === "monthly-cleaning-traceability"
    ) {
      return <ClearOutlined className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "sensor-dashboard" ||
      lastBreadcrumbUrl === "sensor-alerts"
    ) {
      return <ScanOutlined className="BreadcrumbIcon" />;
    } else if (lastBreadcrumbUrl === "tenants") {
      return <BankTwoTone className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "sub-tenants" ||
      lastBreadcrumbUrl === "edit-sub-tenants" ||
      lastBreadcrumbUrl === "add-sub-tenants"
    ) {
      return <BankTwoTone className="BreadcrumbIcon" />;
    } else if (
      [
        "MCQ-management",
        "add-MCQ",
        "edit-MCQ",
        "view-MCQ",
        "tenants",
        "actions",
        "add-actions",
        "alerts",
        "add-alert",
        "edit-alert",
        "components",
        "add-components",
        "designations",
        "add-designation",
        "hierarchy-table",
        "edit-designation",
        "departments",
        "add-department",
        "edit-department",
        "suppliers",
        "add-Supplier",
        "edit-Supplier",
        "allergens",
        "add-allergens",
        "edit-allergens",
        "sensor",
        "add-sensor",
        "edit-sensor",
        "storage-sensor",
        "add-storage-sensor",
        "edit-storage-sensor",
        "storage-instructions",
        "add-storage-instructions",
        "edit-storage-instructions",
        "shelf-life",
        "add-shelf-life",
        "edit-shelf-life",
        "storage",
        "add-storage",
        "live-storage",
        "edit-storage",
        "storage-suggestions",
        "add-storage-suggestions",
        "edit-storage-suggestions",
        "Cooling-Shelf",
        "add-Cooling-Shelf",
        "edit-Cooling-Shelf",
        "ingredients",
        "add-ingredients",
        "edit-ingredients",
        "recipe",
        "add-recipe",
        "edit-recipe",
      ].includes(lastBreadcrumbUrl)
    ) {
      return <DatabaseTwoTone className="BreadcrumbIcon" />;
    } else if (
      lastBreadcrumbUrl === "users" ||
      lastBreadcrumbUrl === "health" ||
      lastBreadcrumbUrl === "protective-clothing" ||
      lastBreadcrumbUrl === "manage-account" ||
      lastBreadcrumbUrl === "user-role" ||
      lastBreadcrumbUrl === "add-users" ||
      lastBreadcrumbUrl === "invite-sub-tenants-users" ||
      lastBreadcrumbUrl === "invite-sub-tenant-users" ||
      lastBreadcrumbUrl === "invite-users"
    ) {
      return <UserOutlined className="UserIcon BreadcrumbIcon" />;
    } else if (lastBreadcrumbUrl === "stock") {
      return <InboxOutlined className="UserIcon BreadcrumbIcon" />;
    }
  };

  const avatarMenu = (
    <Menu>
      <div style={{ padding: "8px 12px", fontWeight: "bold" }}>Account</div>
      <div
        style={{
          padding: "8px 12px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="circle-image-container">
            {SelectedProfile && SelectedProfile[0]?.fileDownloadUri ? (
              <img
                src={SelectedProfile[0]?.fileDownloadUri}
                className="circle-image"
                style={{
                  width: "100%",
                  borderRadius: "50%",
                  background: "black",
                  // background:
                  //   "conic-gradient(yellowgreen, 25%, blue 0 50%,yellow 0 75%,red 0 10%)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  padding: "3px",
                  color: "#fff",
                  cursor: "pointer",
                }}
              />
            ) : (
              <div
                className="circle-image"
                style={{
                  borderRadius: "50%",
                  background: "#001529",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                  padding: "5px",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {firstName}
              </div>
            )}
            <div className="camera-icon" onClick={showProfile}>
              <CameraOutlined />
            </div>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{decodedToken?.name}</span>
            <br />
            <span style={{ fontSize: "12px", color: "grey" }}>
              {decodedToken?.sub}
            </span>
            <br />
            <span style={{ fontSize: "12px", color: "grey" }}>
              {decodedToken?.roles[0] === "SUPER_ADMIN"
                ? "Super Admin"
                : decodedToken?.roles[0] === "TENANT_ADMIN"
                  ? "Account Admin"
                  : decodedToken?.roles[0] === "SUB_TENANT_ADMIN"
                    ? "Store Admin"
                    : decodedToken?.roles[0] === "MANAGER"
                      ? "Manager"
                      : decodedToken?.roles[0] === "SUPERVISOR"
                        ? "Supervisor"
                        : decodedToken?.roles[0] === "SYSTEM_USER"
                          ? "Basic User"
                          : ""}
            </span>
          </div>
        </div>
      </div>
      <Menu.Item key="4" onClick={handleOpenAccountModal}>
        Manage Account
      </Menu.Item>
      {(decodedToken?.roles[0] === "TENANT_ADMIN" || decodedToken?.roles[0] === "SUB_TENANT_ADMIN") && <Menu.Item key="3" onClick={handleOpenCompanyProfile}>
        Company Profile
      </Menu.Item>}
      {/* {decodedToken?.roles[0] === "SUB_TENANT_ADMIN" && <Menu.Item key="3" onClick={handleOpenCompanyProfile}>
        Company Profile
      </Menu.Item>} */}
      {/* <Menu.Item key="3" onClick={handleOpenContactModal}>
        Manage Contacts
      </Menu.Item> */}
      <Menu.Item key="2" onClick={handleChangePassword}>
        Change Password
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1" onClick={handleClearSession}>
        Log out
      </Menu.Item>
    </Menu>
  );

  const [modalEditVisible, setModalEditVisible] = useState(false);

  const handleOpenEditModal = () => {
    setModalEditVisible(true);
  };
  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
  };

  const [src, setSrc] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const cropperRef = useRef(null);
  const switched = localStorage.getItem("switched");
  const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
  console.log(switchedSubtenant);

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => setSrc(reader.result);
      reader.readAsDataURL(e.target.files[0]);
      setIsModalVisible(true);
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  const CurrencyConvert = (value) => {
    const formattedNumber = new Intl.NumberFormat("en-US").format(value);
    return formattedNumber;
  };

  const handleSwitchBack = () => {
    localStorage.removeItem("switched");
    localStorage.removeItem("switchedSubtenant");
    navigate("/dashboard");
    window.location.reload();
  }

  const getCroppedData = async () => {
    const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();

    const croppedBlob = await new Promise((resolve) => {
      croppedCanvas.toBlob((blob) => {
        resolve(blob);
      }, "image/jpeg");
    });
    const uniqueId = `${Date.now()}_${new Date().getSeconds()}`;
    const originalFileName = src.substring(src.lastIndexOf("/") + 1);
    const newFileName = `${uniqueId}_${originalFileName}`;

    const token = localStorage.getItem("UserjwtToken");
    const formData = new FormData();
    const selected = true;
    formData.append("file", croppedBlob, newFileName);
    formData.append("tenantId", decodedToken?.tenantId);
    formData.append("tenantDTO", {
      id: decodedToken?.tenantId,
      tenantApiKey: decodedToken?.tenantApiKey,
    });
    let url = `http://iva-api-dev-681889668.eu-west-1.elb.amazonaws.com:8080/api/v1/user-profile/file-resources/uploads?tenantId=${decodedToken?.tenantId}&userId=${UserDetails?.id}&selected=${selected}`;
    let headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    axios
      .post(url, formData, {
        headers: headers,
      })
      .then((res) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Upload</span>,
          description: "Upload Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        ProfileImage();
        setTimeout(() => {
          window.location.reload();
        }, 600);
      })
      .catch((err) => {
        console.log(err);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Error</span>,
          description: err?.response?.data?.apiError?.message,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#fff2f0",
            color: "red",
          },
        });
      });
    closeModal();
  };

  return (
    <>
      <Header
        className="topHeaderClass"
        style={{
          background: "#fff",
          padding: 0,
          width: "-webkit-fill-available",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 24px",
          }}
        >
          <div style={{ color: "#9A9A9A" }} className="headerUserName">
            Welcome, {decodedToken?.name}!
          </div>
          {!(
            decodedToken?.roles.includes("SUPER_ADMIN") ||
            decodedToken?.roles.includes("TENANT_ADMIN") ||
            decodedToken?.roles.includes("SUB_TENANT_ADMIN")
          ) && (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Input
                  placeholder="Quick Login Code"
                  value={quickCode}
                  onChange={(e) => setQuickCode(e.target.value)}
                  style={{ width: 200 }}
                />
                <Button
                  type="primary"
                  style={{
                    height: "auto",
                    lineHeight: "normal",
                    alignItems: "center",
                    padding: "8px 20px",
                    margin: "0 8px",
                    backgroundColor: "orange", // button background
                    borderColor: "orange",     // border color
                    color: "black"             // text color
                  }}
                  onClick={handleQuickLogin}
                >
                  Quick Login
                </Button>
              </div>
            )}

          <div
            style={{ display: "flex", alignItems: "center" }}
            className="topheader"
          >
             {/* New Product Button */}
            <Link to={"/stock-list"}>
              <Button
                type="primary"
                style={{
                  display: decodedToken?.permissions?.some(
                    permission => permission?.authority === "ADD_PRODUCT"
                  ) ? "flex" : "none",
                  height: "auto",
                  lineHeight: "normal",
                  alignItems: "center",
                  padding: "8px 20px",
                  margin: "0 8px"
                }}
              >
                See Stock
              </Button>
            </Link>

            {/* New Product Button */}
            <Link to={"/product-master-sheet"}>
              <Button
                type="primary"
                style={{
                  display: decodedToken?.permissions?.some(
                    permission => permission?.authority === "ADD_PRODUCT"
                  ) ? "flex" : "none",
                  height: "auto",
                  lineHeight: "normal",
                  alignItems: "center",
                  padding: "8px 20px",
                  margin: "0 8px"
                }}
              >
                New Product
              </Button>
            </Link>

            {/* Goods Inward Button */}
            <Link
              to={"/good-inward-process"}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === "ADD_GOODS_INWARD"
                ) ? "flex" : "none"
              }}
            >
              <Button
                type="primary"
                style={{
                  height: "auto",
                  lineHeight: "normal",
                  padding: "8px 20px",
                  margin: "0 8px"
                }}
              >
                Goods Inward
              </Button>
            </Link>

            {/* Notification and Settings Container */}
            <div style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
              <Notifications />

              <Link
                className={isSubtenantADMIN || isSubtenantUser ? "d-none" : ""}
                to={"/settings"}
                style={{ marginLeft: "16px" }}
              >
                <SettingOutlined
                  style={{
                    fontSize: "20px",
                  }}
                />
              </Link>
            </div>

            {/* User Avatar Dropdown */}
            <Dropdown
              overlay={avatarMenu}
              visible={dropdownVisible}
              onOpenChange={handleDropdownVisibleChange}
              trigger={["click"]}
            >
              {SelectedProfile && SelectedProfile[0]?.fileDownloadUri ? (
                <img
                  src={SelectedProfile[0]?.fileDownloadUri}
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "#001529",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    padding: "3px",
                    color: "#fff",
                    cursor: "pointer",
                    animation: "flash 1s infinite",
                    marginLeft: "16px"
                  }}
                />
              ) : (
                <div
                  className="circle-image"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "#001529",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    padding: "5px",
                    color: "white",
                    cursor: "pointer",
                    animation: "flash 1s infinite",
                    marginLeft: "16px"
                  }}
                >
                  {firstName}
                </div>
              )}
            </Dropdown>
          </div>
        </div>
      </Header>
      <div className="my-4 py-2"></div>
      {switched && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            zIndex: 2000, // keep it on top of other content
          }}
        >
          <Alert
            type="info"
            showIcon={false}
            style={{
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // center the whole message section
            }}
            message={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "15px", // space between text and button
                }}
              >
                <span>
                  You are logged in as {switchedSubtenant?.subTenantName} (
                  {switchedSubtenant?.subTenantCode})
                </span>
                <Button
                  type="primary"
                  size="small"
                  danger
                  onClick={() => handleSwitchBack()}
                >
                  Switch Back
                </Button>
              </div>
            }
          />
        </div>
      )}

      <Card
        bordered={false}
        className="m-3 mb-1 Breadcrumb-class"
        style={{ padding: "0px" }}
      >
        <Row align="middle">
          <Col span={2} className="d-flex" style={{ justifyContent: "center" }}>
            <div className="left-column">{renderIcons()}</div>
          </Col>
          <Col span={20}>
            <div className="d-flex align-items-center">
              <div className="d-flex">
                <div className="right-column mx-2">
                  {hadletcost() ? (
                    <span className="BreadcrumbTitle">
                      {modifiedBreadcrumbUrls[modifiedBreadcrumbUrls.length - 1] === "complaints" ? "Corrective Action / Maintenance Issues" :
                        modifiedBreadcrumbUrls[modifiedBreadcrumbUrls.length - 1] === "create complaint" ? "Corrective Action / Maintenance Issue" :
                          modifiedBreadcrumbUrls[modifiedBreadcrumbUrls.length - 1]}
                    </span>
                  ) : (
                    <span className="BreadcrumbTitle">
                      Stock List
                    </span>
                  )
                  }

                  {lastBreadcrumb2 === "product" ? (
                    <>
                      <Breadcrumb
                        separator={<RightOutlined />}
                        className="breadcrumb pt-1"
                      >
                        <FolderOpenOutlined className="pt-1 px-1" />
                        <Breadcrumb.Item>
                          <span>Product Information</span>
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </>
                  ) : (
                    <>
                      <Breadcrumb
                        separator={<RightOutlined />}
                        className="breadcrumb pt-1"
                      >
                        <FolderOpenOutlined className="pt-1 px-1" />
                        {hadletcost() ?

                          modifiedBreadcrumbUrls.map((item, index) => (
                            item === "complaints" ?
                              <Breadcrumb.Item key={index}>
                                <span>Corrective Action / Maintenance Issue</span>
                              </Breadcrumb.Item>
                              : item === "create complaint" ?
                                <Breadcrumb.Item key={index}>
                                  <span>Create Corrective Action / Maintenance Issue</span>
                                </Breadcrumb.Item>
                                : item === "complaint reply" ?
                                  <Breadcrumb.Item key={index}>
                                    <span>Corrective Action Reply</span>
                                  </Breadcrumb.Item>
                                  :
                                  <Breadcrumb.Item key={index}>
                                    <span>{item}</span>
                                  </Breadcrumb.Item>

                          )) :
                          <Breadcrumb.Item >
                            <span>Stock List</span>
                          </Breadcrumb.Item>}
                      </Breadcrumb>
                    </>
                  )}
                </div>

                {lastBreadcrumbUrl && lastBreadcrumbUrl === "production" && (
                  <div>
                    {/* <Link
                      type="primary"
                      to={"/stock-list"}
                      className="btn btn-primary btn-save mx-4"
                    >
                      See live Stock
                    </Link> */}
                    {/* <Link to={"/stock-list"}>
                  <Button
                    type="primary"
                    style={{
                      display: "block",
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                    See Stock
                  </Button>
                </Link> */}
                  </div>
                )}
                {lastBreadcrumbUrl &&
                  lastBreadcrumbUrl === "sensor-dashboard" && (
                    <div>
                      <Link
                        type="primary"
                        to={"/sensor-alerts"}
                        className="btn btn-primary btn-save mx-4"
                      >
                        See Alerts
                      </Link>
                    </div>
                  )}
              </div>
              <div>
                <div className="d-flex">
                  <div>
                    {lastBreadcrumbUrl && lastBreadcrumbUrl === "stock" && hadletcost() && (
                      <>
                        {" "}
                        <div
                          className="d-flex px-4"
                          style={{ alignItems: "center" }}
                        >
                          <h4 className="BreadcrumbTitle">INVOICE # &nbsp;</h4>{" "}
                          <h4> {invoice}</h4>
                          <br />
                        </div>
                        <div
                          className="d-flex px-4"
                          style={{ alignItems: "center" }}
                        >
                          <h4 className="BreadcrumbTitle">
                            Total Cost : &nbsp;
                          </h4>{" "}
                          <h4>
                            {" "}
                            {TotalData.length > 0
                              ? TotalData[0]?.productDTOs[0]?.currency
                              : ""}{" "}
                            {CurrencyConvert(TotalCost)}
                          </h4>
                        </div>


                      </>
                    )}
                  </div>
                  <div className="d-flex">
                    {lastBreadcrumbUrl &&
                      lastBreadcrumbUrl === "allergens-sheet" && (
                        <>
                          <div
                            className="d-flex px-4"
                            style={{ alignItems: "center" }}
                          >
                            <PrinterOutlined
                              onClick={() => handleClickPrint()}
                              className="PrintAllergens"
                            />
                          </div>
                        </>
                      )}
                    {lastBreadcrumbUrl && lastBreadcrumbUrl === "stock" && (

                      <>
                        {hadletcost() && (
                          <div
                            className="d-flex px-4"
                            style={{ alignItems: "center" }}
                          >
                            <PrinterOutlined
                              onClick={() => handleClickPrint()}
                              className="PrintAllergens"
                            />
                          </div>
                        )}
                      </>
                    )}
                    {((lastBreadcrumbUrl && lastBreadcrumbUrl === "reheat") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "cooling-process") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "cold-traceability") ||
                      (lastBreadcrumbUrl && lastBreadcrumbUrl === "hot-hold") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "after-cook") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "good-inward-process") ||
                      (lastBreadcrumbUrl && lastBreadcrumbUrl === "recipe") ||
                      (lastBreadcrumbUrl && lastBreadcrumbUrl === "users") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "product-master-sheet") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "allergens") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "inventory-reports") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "waste-reports") ||
                      (lastBreadcrumbUrl &&
                        lastBreadcrumbUrl === "fridge-temperature-report")) && (
                        <>
                          <div
                            className="d-flex px-4"
                            style={{ alignItems: "center" }}
                          >
                            <PrinterOutlined
                              onClick={() => handleClickPrint2()}
                              className="PrintAllergens"
                            />
                          </div>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col span={1}>
            <DashboardOutlined
              className="p-1 quick-dashboard"
              onClick={() => navigate("/dashboard")}
            />
          </Col>
          <Col span={1}>
            <LeftOutlined
              className="p-1 close-slider"
              onClick={handleOpenEditModal}
            />
          </Col>
        </Row>
      </Card>
      {modalEditVisible && (
        <DepartmentSelect
          visible={modalEditVisible}
          onClose={handlEditeCloseModal}
        />
      )}
      <Modal
        open={isModalProfile}
        onOk={handleOk}
        maskClosable={false}
        closable={false}
        footer={[]}
      >
        {" "}
        <div className="modal-header p-0 ">
          <CloseOutlined
            onClick={handleCancelProfile}
            style={{ visibility: "hidden" }}
            className="close-icon"
          />
          <Title level={4} className="Primary-Font pt-3">
            foodflow Account
          </Title>
          <CloseOutlined onClick={handleCancelProfile} className="close-icon" />
        </div>
        <h5 style={{ fontSize: "16px", paddingTop: "26px" }}>
          Profile picture
        </h5>
        <p>
          A picture helps people recognize you and lets you know ehrn you're
          signed in to your account
        </p>
        <div className="product-model text-center">
          <br />

          <Controller
            name="uploadFile"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <input
                  type="file"
                  id="fileInput"
                  style={{ visibility: "hidden", display: "none" }}
                  onChange={onSelectFile}
                  accept="image/*"
                />
                <div className="d-flex justify-content-center">
                  {SelectedProfile && SelectedProfile[0]?.fileDownloadUri ? (
                    <label htmlFor="fileInput">
                      <img
                        src={SelectedProfile[0]?.fileDownloadUri}
                        style={{
                          borderRadius: "50%",
                          display: "flex",
                          background: "#001529",
                          height: "250px",
                          width: "250px",
                          justifyContent: "center",
                          alignItems: "center",
                          fontWeight: "bold",
                          padding: "5px",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      />
                    </label>
                  ) : (
                    <label htmlFor="fileInput">
                      {" "}
                      <div
                        className="circle-image "
                        style={{
                          borderRadius: "50%",
                          background: "#001529",
                          display: "flex",
                          height: "200px",
                          fontSize: "50px",
                          width: "200px",
                          justifyContent: "center",
                          alignItems: "center",
                          fontWeight: "bold",
                          padding: "5px",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        {firstName}
                      </div>{" "}
                    </label>
                  )}
                </div>

                <Modal
                  title="Crop Image"
                  visible={isModalVisible}
                  onOk={getCroppedData}
                  okText="Upload"
                  maskClosable={false}
                  onCancel={closeModal}
                >
                  {src && (
                    <Cropper
                      ref={cropperRef}
                      src={src}
                      aspectRatio={1}
                      style={{ height: 300, width: "100%" }}
                      cropShape="round"
                    />
                  )}
                </Modal>
              </>
            )}
          />
        </div>
        {SelectedProfile && SelectedProfile[0]?.fileDownloadUri ? (
          <div className="d-flex justify-content-center pt-4">
            <Button
              type="button"
              className="btn btn-primary btn-back mx-2 d-flex justify-content-center"
              onClick={RemoveImage}
            >
              <DeleteOutlined />
              Remove
            </Button>
          </div>
        ) : (
          <></>
        )}
      </Modal>
      {/* <Modal
        open={EnableTenacy}
        onCancel={handleCancelProduct}
        footer={[]}
        maskClosable={false}
      >
        <div className="product-model text-center">
          <b>You need to setup Following Items</b>
          <br />

          <br />
          {ADMIN_PERMISSION && (
            <>
              <p style={{ textAlign: "start" }}>
                {" "}
                To setup Tenant Admin Permissions.{" "}
                <Link to={"/settings/set-permissions"}> click here</Link>{" "}
              </p>
            </>
          )}

          {modalcurrencyVisible && (
            <>
              <p style={{ textAlign: "start" }}>
                You have not set up the system default currency. Please set the
                currency
                <Link to={"/settings/currency-configurations"}>
                  {" "}
                  click here
                </Link>
              </p>
            </>
          )}
          {modalTimeVisible && (
            <>
              <p style={{ textAlign: "start" }}>
                To setup Tenant Admin Time Configurations.{" "}
                <Link to={"/settings/time-configurations"}> click here</Link>{" "}
              </p>
            </>
          )}
        </div>

        <div className="d-flex justify-content-center"></div>
      </Modal> */}
      <Contact visible={modalContactVisible} onClose={handlContactCloseModal} />
    </>
  );
};

export default TopHeader;